<template>
  <div class="accordion-faq wow move-up">
    <b-card no-body>
      <b-card-header header-tag="header">
        <b-button block v-b-toggle.accordion-1 class="faq-title">How YourSynchronicity help to
          prevent my account from being restricted
        </b-button>
      </b-card-header>
      <b-collapse id="accordion-1" visible accordion="my-accordion">
        <b-card-body>
          <b-card-text>
            Before being restricted by LinkedIn, there is some hints that AI software
            of LinkedIn got eyes on you, so our job is to notify you as soon as possible.
            and give you some recommendations on how to avoid any other alarming behavior.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body>
      <b-card-header header-tag="header">
        <b-button block v-b-toggle.accordion-2 class="faq-title">Is it possible to start new
          conversation with my 1st network only if not contact on a certain period
        </b-button>
      </b-card-header>
      <b-collapse id="accordion-2" accordion="my-accordion">
        <b-card-body>
          <b-card-text>
            YourSynchronicity has the ability, the spot the date of the last message, and hence
            avoid
            spamming users and try as best effort to keep your linkedIn image the best.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body>
      <b-card-header header-tag="header">
        <b-button block v-b-toggle.accordion-3 class="faq-title">Do I need to know how to code for
          this tool?
        </b-button>
      </b-card-header>
      <b-collapse id="accordion-3" accordion="my-accordion">
        <b-card-body>
          <b-card-text>
            Never! YourSynchronicity is no-code platform, it doesn't matter whether you are a sales
            person or
            into marketing. YourSynchronicity makes it easy for you to run automation by simply
            providing the
            configuration. Our support team 💪 are always here to help you by chat and email should
            you need assistance.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body>
      <b-card-header header-tag="header">
        <b-button block v-b-toggle.accordion-4 class="faq-title">On-demand Extra Services</b-button>
      </b-card-header>
      <b-collapse id="accordion-4" accordion="my-accordion">
        <b-card-body>
          <b-card-text>
            YourSynchronicity is evolving, if you got any idea that you would love to have into
            YourSynchronicity, our support team will be glad to talk to you about it and add it for
            you, and you'll have a little present ⭐ with it.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
    <b-card no-body>
      <b-card-header header-tag="header">
        <b-button block v-b-toggle.accordion-5 class="faq-title">What if I have more questions?
        </b-button>
      </b-card-header>
      <b-collapse id="accordion-5" accordion="my-accordion">
        <b-card-body>
          <b-card-text>
            you can email us at <a style="color:blue" href="mailto:support@yoursynchronicity.com">support@yoursynchronicty.com</a> for more help.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
    export default {
        name: 'Accordion',
    };
</script>

